var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWrLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 348 263",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.663 225.314l-11.162 19.307-7.815-13.529-5.228-9.046-5.222 9.019-7.746 13.397-11.072-19.148H0l16.289 28.168 5.222 9.046 5.201-9.02 7.746-13.396 7.815 13.529 5.228 9.041 5.222-9.02 16.374-28.348H58.663zM106.095 225.409v4.489a20.342 20.342 0 00-6.727-4.586 20.398 20.398 0 00-7.989-1.585c-11.109 0-20.12 8.733-20.12 19.477s9.032 19.477 20.12 19.477a20.375 20.375 0 0014.7-6.17v5.152h9.962v-36.254h-9.946zM94.12 255.317c-7.087 0-12.835-5.422-12.835-12.113 0-6.69 5.732-12.091 12.82-12.091 5.466 0 10.157 3.226 11.974 7.778v8.648a12.786 12.786 0 01-4.794 5.706 12.818 12.818 0 01-7.165 2.072zM154.776 225.314l-11.029 19.084-11.045-19.084h-10.594l16.326 28.258 5.313 9.173 5.313-9.195 16.331-28.236h-10.615zM202.463 248.473c-2.125 3.274-6.375 6.367-11.338 6.367-7.023 0-12.623-2.945-12.623-10.362h31.053c.027-.414.069-.822.069-1.241 0-10.914-8.861-19.764-20.448-19.764s-20.98 8.85-20.98 19.764c0 10.913 9.393 19.763 20.98 19.763 8.564 0 15.938-4.839 19.179-11.763l-5.892-2.764zm-12.841-17.328c5.021 0 9.09 2.626 9.09 6.775h-18.648c.755-4.658 4.537-6.775 9.558-6.775z",
    fill: "#F1F6F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M286.888 248.473c-2.125 3.274-6.376 6.367-11.332 6.367-7.024 0-12.623-2.945-12.623-10.362h31.053c.026-.414.063-.822.063-1.241 0-10.914-8.856-19.764-20.443-19.764-11.587 0-20.985 8.85-20.985 19.764 0 10.913 9.393 19.763 20.985 19.763 8.559 0 15.912-4.839 19.174-11.763l-5.892-2.764zm-12.841-17.328c5.026 0 9.095 2.626 9.095 6.775h-18.679c.754-4.658 4.537-6.775 9.557-6.775h.027zM239.604 222.916c-3.862.323-6.79 2.838-8.707 5.157v-3.969h-9.972v36.678h9.961v-23.27c1.291-2.781 3.156-5.508 5.695-6.367 5.844-1.974 8.947 1.273 8.947 1.273l4.478-6.961s-3.065-3.151-10.402-2.541zM344.796 253.02v8.223h-46.89l8.235-8.223 21.362-21.334h-22.446v-8.245H348l-8.256 8.245-21.384 21.334h26.436z",
    fill: "#2EDFF1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M237.092 28.316a92.077 92.077 0 0114.021 110.018s-24.63-21.435-33.391-46.127c-8.76-24.693 1.063-32.831 1.063-32.831s3.446.536 5.858 2.581c1.423 1.207 3.554 2.003 4.708.538.863-1.096 1.662-2.572 1.913-4.44.633-4.728.165-9.55-4.781-15.238 0 0-1.541-7.01 1.907-10.983 2.625-3.056 8.702-3.518 8.702-3.518zM192.71 3.306l.398-.143a92.35 92.35 0 00-52.135 2.335 92.233 92.233 0 00-42.521 30.218 92.008 92.008 0 00-9.181 99.557C130.81 22.401 192.71 3.306 192.71 3.306z",
    fill: "#F1F6F7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M259.981 30.706c1.984 1.219 4.809.694 5.032-1.622.737-7.664-1.351-21.588-24.26-27.19-38.597-9.433-80.541 16.936-113.602 66.32 0 0 28.157-31.037 61.462-35.276 14.414-1.83 26.989-.282 37.912 9.879 0 0 3.581-9.02 14.876-12.606 8.272-2.627 14.336-2.112 18.58.495z",
    fill: "url(#wrLogo_svg__paint0_linear_7_134)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M224.245 59.231c1.716 1.013 4.081.532 4.431-1.428.934-5.238-.053-14.617-16.405-20.133-22.52-7.587-53.94 4.775-75.44 28.29-21.501 23.514-35.064 49.873-39.75 61.333 0 0 21.484-34.906 51.618-35.75 18.001-.502 23.738 6.85 24.716 13.123.753 4.826-4.685 4.24-9.561 4.607-2.346.176-5.167 1.404-8.37 4.66-9.797 9.959-9.611 35.182 10.545 51.741 20.157 16.559 35.797 22.766 35.797 22.766s24.774.043 48.793-13.168c0 0-32.966-17.509-49.547-42.148-16.581-24.64-15.072-57.757-.186-70.565 10.19-8.767 18.886-5.967 23.359-3.328z",
    fill: "url(#wrLogo_svg__paint1_linear_7_134)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M166.701 106.917c1.996.238 4.667-1.193 4.032-3.097-1.647-4.94-7.285-11.44-25.923-9.29-31.435 3.624-50.157 47.438-50.157 47.438s28.816 48.165 104.368 46.472c0 0-50.115-19.944-52.187-51.74-1.632-25.047 12.052-30.713 19.867-29.783z",
    fill: "url(#wrLogo_svg__paint2_linear_7_134)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M218.806 59.376s-14.803 53.371 48.853 97.834c1.184.828 1.407 2.529.391 3.556-3.473 3.509-10.947 10.713-16.278 13.375 0 0-60.098-32.55-60.475-75.822-.377-43.273 27.509-38.944 27.509-38.944z",
    fill: "url(#wrLogo_svg__paint3_linear_7_134)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "wrLogo_svg__paint0_linear_7_134",
    x1: 108.162,
    y1: -14.676,
    x2: 107.726,
    y2: 188.443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2EDFF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#13BAEB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "wrLogo_svg__paint1_linear_7_134",
    x1: 108.162,
    y1: -14.676,
    x2: 107.726,
    y2: 188.443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2EDFF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#13BAEB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "wrLogo_svg__paint2_linear_7_134",
    x1: 108.162,
    y1: -14.676,
    x2: 107.726,
    y2: 188.443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2EDFF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#13BAEB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "wrLogo_svg__paint3_linear_7_134",
    x1: 108.162,
    y1: -14.676,
    x2: 107.726,
    y2: 188.443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2EDFF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#13BAEB"
  })))));
}
export default SvgWrLogo;